module.exports = __webpack_public_path__ + "media/icons/brand/regular-01177847722b8d0300509875b58a2b34.svg";